import { render, staticRenderFns } from "./PersonDetails.vue?vue&type=template&id=d88f82f4&scoped=true&"
import script from "./PersonDetails.vue?vue&type=script&lang=js&"
export * from "./PersonDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d88f82f4",
  null
  
)

export default component.exports